import { LOCATION_CHANGE, LocationChangeAction } from "connected-react-router";

let prevPathname = "";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function referrerPathname(state = "", action: LocationChangeAction) {
  switch (action.type) {
    case LOCATION_CHANGE: {
      const newState = prevPathname;
      prevPathname = `${action.payload.location.pathname}${action.payload.location.search}`;
      return newState;
    }

    default:
      return state;
  }
}
